// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import apis from './config/request';
import App from './App'
import router from './router'
import store from './store';
import VueClipBoard from 'vue-clipboard2'

Vue.prototype.apis = apis;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueClipBoard)


if (sessionStorage.getItem('store')) {
  store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store'))))
}
// 在页面刷新时将store保存到sessionStorage里
window.addEventListener('beforeunload', () => {

  sessionStorage.setItem('store', JSON.stringify(store.state))
})
//登录拦截
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {//requireAuth若为true则该路由需要判断是否登录
    if (store.state.userId) {//判断当前的userName数据是否存在
      next();
    }
    else {
      next({//返回登录页面
        path: '/',
      })
    }
  }
  else {
    next();
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js